import React, { lazy } from "react";
import Page from "components/Page";
import { Props } from "./GuaranteeHistorys";

const GuaranteeHistorys = lazy(() => import("./GuaranteeHistorys"));

export default (props: Props) => (
  <Page>
    <GuaranteeHistorys {...props} />
  </Page>
);
